import { BaseProduct, ProductConfig } from "@utils/product/product-utils-types";
import { AllBundlesTypes } from "@utils/product/product-types";
import { createProductsFromConfigs } from "@utils/product/product-utils";

const bundles: Record<AllBundlesTypes, ProductConfig> = {
  dashboard: {
    scopesWithoutLimit: ["COMPANY"],
  },
  edu: {
    scopesWithoutLimit: ["PROJECT"],
    scopesWithEditableLimit: ["COMPANY"],
    isCoreProduct: true,
    apps: ["holoBuilder"],
  },
  ["plan-fm"]: {
    scopesWithoutLimit: ["PROJECT"],
    scopesWithEditableLimit: ["COMPANY"],
    isCoreProduct: true,
    apps: ["holoBuilder"],
  },
  ["premium-insights"]: {
    scopesWithoutLimit: ["COMPANY"],
  },
  gps: {
    scopesWithoutLimit: ["COMPANY", "PROJECT"],
  },
  snapshot: {
    scopesWithoutLimit: ["COMPANY", "PROJECT"],
  },
  vpm: {
    scopesWithEditableLimit: ["PROJECT"],
    isCoreProduct: true,
  },
  ["vpm-enterprise"]: {
    scopesWithoutLimit: ["COMPANY"],
    isCoreProduct: true,
    apps: ["holoBuilder"],
  },
  pointcloud: {
    scopesWithoutLimit: ["COMPANY", "PROJECT"],
    isCoreProduct: true,
  },
  ["cloud-processing"]: {
    scopesWithoutLimit: ["COMPANY", "PROJECT"],
  },
  cad: {
    scopesWithoutLimit: ["COMPANY", "PROJECT"],
    isCoreProduct: true,
  },
  flash: {
    scopesWithoutLimit: ["DEVICE"],
    isCoreProduct: true,
  },
  ["faro-stream"]: {
    scopesWithoutLimit: ["DEVICE"],
    isCoreProduct: true,
  },
  ["floorplan-generator"]: {
    scopesWithoutLimit: ["COMPANY", "PROJECT"],
    isCoreProduct: true,
  },
  /**
   * Every workspace holds this technical plan already, so it is never created as part of the
   * regular support work. It is only offered behind the "Show all products" dev tool, to restore
   * a workspace whose minimal plan went missing.
   */
  minimal: {
    scopesWithoutLimit: ["COMPANY"],
  },
  ["hb-to-sxg-migrated"]: {
    scopesWithoutLimit: ["COMPANY", "PROJECT"],
    isCoreProduct: true,
    description:
      "Forces all users in the workspace to use Sphere XG and redirects all existing links to XG",
  },
};

/** List of all available bundles in Admin Panel */
export const allAvailableBundles: Record<AllBundlesTypes, BaseProduct> =
  createProductsFromConfigs(bundles);
